<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <!-- ---------------------- 索引表格 ---------------------- -->
    <div class='global-panel' v-loading.body="loading.main">
      <div class="global-header">
        <div class="global-title">教师管理</div>
        <div class='global-tbar'>

          <el-upload class="upload-demo"
                     :action="'rest/staff/uploadStaffFile' "
                     :on-progress="uploadProgress"
                     :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                     :on-remove="handleRemove" :file-list="fileList" :show-file-list='false'
                     list-type="picture">
            <el-button type="primary" size="small" icon="el-icon-upload2">上传excel</el-button>
          </el-upload>
          <el-button size="small" type="success"  @click="downloadAttachment()">下载模板</el-button>
          <el-button size="small" type="danger"  @click="addStaff()">新增</el-button>
          <el-input size="small" v-model="condition.staffName" placeholder="姓名"></el-input>
          <el-input size="small" v-model="condition.seriaNo" placeholder="职工号"></el-input>
          <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
        </div>
      </div>
      <hr>
      <div class='global-body'>
        <div class="global-paging" v-show="paging.allNum > paging.everySize" >
          <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
        </div>
        <el-table :data="staffList" border stripe style="width: 100%" size="mini" highlight-current-row >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="seriaNo" label="职工号" width="200"></el-table-column>
          <el-table-column prop="staffName" label="姓名" width="150" sortable></el-table-column>
          <el-table-column prop="gender" label="性别" width="150" sortable></el-table-column>
          <el-table-column prop="telephone" label="手机号" width="200" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="note" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button class="global-text-btn-success" size="mini" type="text" @click="showStaff(scope.row)" style="margin-left: 10px;">编辑</el-button>
              <el-button class="global-text-btn-danger" size="mini" type="text" @click="dropStaff(scope.row)" style="margin-left: 10px;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页  -->
        <div v-show="paging.allNum > paging.everySize" class="global-paging">
          <hr/>
          <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="visible.param" width="50%" v-loading="loading.param" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="serverForm"  :model="currentRecord" label-width="80px":rules="serverRules">
        <el-form-item label="教工号" prop="seriaNo">
          <el-input v-model="currentRecord.seriaNo"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="staffName">
          <el-input v-model="currentRecord.staffName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="currentRecord.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select v-model="currentRecord.gender" placeholder="请选择">
            <el-option
              v-for="item in genderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="telephone">
          <el-input v-model="currentRecord.telephone"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.param = false">取 消</el-button>
      <el-button type="primary" @click="saveStaff()">保 存</el-button>
    </span>
    </el-dialog>
  </div>
</template>
<script>

  export default {
    name: 'Teacher',
    data () {
      return {
        // 遮罩
        loading: {main: false, param: false},
        // 可见
        visible: {param: false},
        // 检索条件
        condition: {staffName:null, seriaNo : null, clazzName : null},
        // 数据
        staffList: [],
        // 当前记录
        currentRecord: {},
        // 分页
        paging: {currPage: 1, everySize: 15, allNum: 0},
        // 校验规则
        serverRules: {
          seriaNo: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          staffName: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          gender: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
        },
        fileList:[],
        genderOptions:[
          {
            value: '男',
            label: '男'
          }, {
            value: '女',
            label: '女'
          }
        ]
      }
    },

    /*
     * 初始化
     */
    mounted: function () {
      var vm = this;
      vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';

      vm.findByCondition();
    },

    methods: {
      /*
      * 查询所有
      */
      findByCondition: function (currentPage) {
        var vm = this;
        // 区分分页与查询
        if(currentPage){
          vm.paging.currPage = currentPage;
        } else {
          vm.paging.currPage = 1;
        }
        // 开启遮罩
        vm.loading.main = true;
        var params = vm.condition
        params.currPage = vm.paging.currPage
        params.everySize = vm.paging.everySize
        // 请求后台
        vm.$http.get('rest/staff/findByCondition', {params: params}).then(response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 更新数据
          vm.staffList = response.body.staffList;
          vm.paging = response.body.pagingBean;
          // 提示
          vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
        }, response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      },
      addStaff: function () {
        var vm = this;
        vm.currentRecord = {id:null,seriaNo:null,password:null,studentName:null,telephone:null,note:null};
        vm.visible.param = true;
      },
      showStaff: function (record) {
        var vm = this;
        vm.currentRecord = JSON.parse(JSON.stringify(record));
        vm.visible.param = true;
      },
      dropStaff: function (record) {
        var vm = this;
        vm.$confirm('确定要【删除】职工[' + record.staffName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
          // 开启遮罩
          vm.loading.main = true;
          // 请求后台
          vm.$http.post('rest/staff/dropStaff', null, {params: {id:record.id}}).then(function (response) {
            // 关闭遮罩
            vm.loading.main = false;
            vm.findByCondition(vm.paging.currPage);
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.main = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        }).catch(() => {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
        });
      },
      saveStaff: function () {
        var vm = this;
        // 校验
        vm.$refs['serverForm'].validate((valid) => {
          if (!valid) {
            // 提示信息
            vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
            // 获取焦点
            vm.$nextTick(() => {
              vm.$refs['serverForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
            })
            return false;
          }
          // 开启遮罩
          vm.loading.param = true;
          // 请求后台
          vm.$http.post('rest/staff/saveStaff', vm.currentRecord).then(function (response) {
            // 关闭遮罩
            vm.loading.param = false;
            // 关闭窗口
            vm.visible.param = false;
            // 刷新
            vm.findByCondition(vm.paging.currPage);
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.param = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        });
      },
      uploadProgress:function (event, file, fileList){
        var vm =this
        vm.loading.main = true;
      },
      uploadError:function (err, file, fileList){
        var vm =this
        vm.loading.main = false;
        // 弹出错误信息
        this.$alert(JSON.parse(err.message).message, '警告', {
          confirmButtonText: '确定',
          type: 'error'
        });
      },
      uploadSuccess:function (){
        var vm =this
        vm.loading.main = false;
        vm.$notify({position: 'bottom-right', type: 'success', message: '上传成功'});
        vm.findByCondition()
      },
      handlePreview:function (){

      },
      handleRemove:function (){
      },
      // 下载附件
      downloadAttachment: function (record) {
        var vm = this;
        // 开启遮罩
        vm.loading.main = true;
        let xhr = new XMLHttpRequest();
        xhr.open('POST', '/rest/staff/download', true);
        xhr.responseType = 'arraybuffer';
        xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
        xhr.onreadystatechange = function (event) {
          if (this.readyState == 4 && this.status == 200) {
            // 关闭遮罩
            vm.loading.main = false;
            let contentDisposition = xhr.getResponseHeader('Content-Disposition');
            let index = contentDisposition.indexOf("attachment; filename=");
            let fileName = "未知文件"
            if (index >= 0) {
              fileName = contentDisposition.substring(index + 21);
            }
            //生成Blob对象，通过创建的a标签点击下载
            var objectUrl = URL.createObjectURL(new Blob([this.response]));
            var link = document.createElement("a");
            link.download = decodeURIComponent(fileName);
            link.href = objectUrl;
            link.click();
          } else if (this.readyState == 4 && this.status != 200) {
            // 关闭遮罩
            vm.loading.main = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
            vm.$baize.handle(vm, {status: this.status, body: this.response});
          }
        };
        xhr.send();
      }

    }
  }
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/app/Staff.vue